export const VERIFICATION_JSON = "verification_json",
  PINTOPINSIM_RAW_FAST = "pintopinsim_raw",
  PINTOPINSIM_RAW_HIRE = "pintopinsim_raw_hire",
  PDN_RAW = "pdn_raw",
  PDN_RAW_HIRE = "pdn_raw_hire",
  PDN_NPI = "pdn_npi",

  EYE_MARGINS = "eye_margins",

  MASK_JSON = "mask_json",

  EYE_DIAGRAM_PNG = "eye_diagram_png",
  EYE_PARAMETER_JSON = "eye_parameter_json",
  EYE_DIAGRAM_PNG_JSON = "eye_diagram_png_json",
  WAVE_PARAMETER_JSON = "wave_parameter_json",
  EYE_DIAGRAM_ADJUSTED_PNG = "eye_diagram_adjusted_png",
  EYE_PARAMETER_ADJUSTED_JSON = "eye_parameter_adjusted_json",
  EYE_DIAGRAM_ADJUSTED_PNG_JSON = "eye_diagram_adjusted_png_json",
  WAVE_PARAMETER_ADJUSTED_JSON = "wave_parameter_adjusted_json",

  // EYE_DIAGRAM_JSON = "eye_diagram_json",
  // EYE_DIAGRAM_ADJUSTED_JSON = "eye_diagram_adjusted_json",

  STAT_EYE_DIAGRAM_PNG = "stat_eye_diagram_png",
  STAT_EYE_PARAMETER_JSON = "stat_eye_parameter_json",
  
  STAT_EYE_PDN_RAW = "stat_eye_pdn_raw",
  STAT_EYE_PDN_RAW_HIRE = "stat_eye_pdn_raw_hire";


const marginObj = {
  'eyeWidth': { name: 'Eye Width', unit: 'ps' },
  'eyeHeight': { name: 'Eye Height', unit: 'mV' },
  'bottomMargin': { name: 'Bottom Margin', unit: 'mV' },
  'topMargin': { name: 'Top Margin', unit: 'mV' },
  'setupMargin': { name: 'Setup Margin', unit: 'ps' },
  'holdMargin': { name: 'Hold Margin', unit: 'ps' },
  'jitter': { name: 'Jitter', unit: 'ps' }
}

export {
  marginObj
}

